import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/24/outline';
import { shopApi } from '../../../utils/shopApi';
import { Skeleton } from '../../../components/ui';
import '../booking-shared.css';
import '../checkout.css';
import './shop.css';

export default function ShopConfirmation() {
  const { orderId } = useParams();
  const [searchParams] = useSearchParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    shopApi.getOrder(orderId)
      .then(res => setOrder(res.data))
      .catch(() => setLoadError(true))
      .finally(() => setLoading(false));
  }, [orderId]);

  const paymentStatus = searchParams.get('redirect_status');

  if (loading) return <div className="bk-page bk-page--narrow"><Skeleton rows={2} label="Loading order…" /></div>;

  if (paymentStatus === 'failed') {
    return (
      <div className="bk-page bk-page--narrow checkout-done">
        <span className="checkout-done__icon checkout-done__icon--bad"><XCircleIcon aria-hidden="true" /></span>
        <h1 className="checkout-done__title">Payment failed</h1>
        <p className="checkout-done__text">Your payment was not processed. Please try again.</p>
        <div className="checkout-done__links">
          <Link to="/booking/cart" className="bk-link">Back to cart</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bk-page bk-page--narrow checkout-done">
      <span className="checkout-done__icon"><CheckCircleIcon aria-hidden="true" /></span>
      <h1 className="checkout-done__title">Order placed!</h1>
      <p className="checkout-done__text">Thanks for your order. We'll email you when your kit arrives at the club.</p>
      {order && <p className="bk-small">Order ref: {order.id}</p>}
      {loadError && <p className="bk-small">Couldn't load the order details. Your orders are in My orders.</p>}
      <div className="checkout-done__links">
        <Link to="/booking/my-orders" className="bk-link">View my orders</Link>
        <Link to="/booking/shop" className="bk-link">Continue shopping</Link>
      </div>
    </div>
  );
}
